<template>
  <div class="box text-center">
    <!-- /.box-header -->
    <div class="box-body" v-if="!adjustList.length">
      無配料群組，請新增
    </div>
    <div class="box-body" v-else>
      <div class="col-xs-12">
        <div class="inline-block pull-left">
          <h4 class="pull-left">配料群組</h4>
        </div>
        <div>
          <button class="btn btn-danger m-y-10 inline-block pull-right" data-toggle="modal" data-target="#delModal" @click="delModalOpen">
            刪除
          </button>
          <button
            class="btn btn-default btn-black m-y-10 inline-block pull-right m-r-10"
            @click="gotoCrAdjusts"
          >
            新增
          </button>
          <button class="btn btn-default btn-black m-y-10 inline-block pull-right m-r-10" data-toggle="modal" @click="show.easy = !show.easy">
            <span v-if="!show.easy">簡易</span>
            <span v-else>進階</span>
          </button>
        </div>
      </div>
      <div class="col-xs-12">
        <div class="col-xs-12 col-md-2 bg-light-gray select-element-block text-left">
          <div class="select-element" v-for="(adjust, index) in adjustList" :class="{'active': curId === adjust.item_id}" @click="clickAdjust(adjust, index)" :disabled="isLoad || curId === adjust.item_id">
            <span class="text-w-600">{{adjust.name}}</span> <small style="opacity: .7;">&nbsp;&nbsp;{{adjust.remark}}</small>
          </div>
        </div>
        <div class="col-xs-12 col-md-10">
          <div class="box-body form menu-form col-xs-12">
            <div class="col-xs-12 col-md-6 p-r-5">
              <div class="input-group">
                <span class="input-group-addon"><span class="text-red">＊ </span>分類</span>
                <div class="form-group">
                  <select class="form-control" v-model="adjustInfo.sub_type">
                    <option :value="10">大小</option>
                    <option :value="20">容器</option>
                    <option :value="30">甜度</option>
                    <option :value="40">溫度</option>
                    <option :value="0">其他</option>
                  </select>
                </div>
              </div>
              <br />
              <div class="input-group">
                <span class="input-group-addon"><span class="text-red">＊ </span>調整類別名稱</span>
                <input class="form-control" placeholder="" type="text" v-model="adjustInfo.name" maxlength="32">
              </div>
              <br />
              <div class="input-group">
                <span class="input-group-addon">
                  <span class="text-red">＊ </span>排序
                  <span 
                    data-toggle="tooltip" 
                    class="tip-icon" 
                    data-placement="bottom" 
                    data-container="body"
                    title="菜單上呈現分類順序預設為：(大小)>(溫度>甜度>容器)>(其他)，括弧內的項目可依排序值調整順序。"
                  >
                    <i class="fa fa-question-circle" aria-hidden="true"></i>
                  </span>
                </span>
                <input class="form-control" placeholder="" type="text" v-model="adjustInfo.sort" @keyup="veritySort" maxlength="4" ref="sort">
              </div>
              <br />
              <div class="input-group">
                <span class="input-group-addon"><span class="text-red">＊ </span>必選項目</span>
                <div class="radio text-left h-38" style="border-left: 1px solid #d2d6de;">
                  <label class="m-l-15">
                    <input type="radio" name="mandatoryRadio" :value="1" v-model="adjustInfo.is_mandatory" style="top: 12px;">
                    <div style="top: 8px; left: 8px;">是</div>
                  </label>
                  <label class="m-l-15">
                    <input type="radio" name="mandatoryRadio" :value="0" v-model="adjustInfo.is_mandatory" style="top: 12px;">
                    <div style="top: 8px; left: 8px;">否</div>
                  </label>
                </div>
              </div>
              <br />
              <div class="input-group">
                <span class="input-group-addon"><span class="text-red">＊ </span>選購數量</span>
                <div>
                  <input style="width: calc(50% - 10px)" class="c-auto form-control" placeholder="0為無上限" type="text" @keyup="verityMinLimit()" v-model="adjustInfo.min_limit" maxlength="9" ref="minLimit">
                  <span class="pull-left" style="line-height: 38px; width: 20px">~</span>
                  <input style="width: calc(50% - 10px)"  class="c-auto form-control" placeholder="0為無上限" type="text" @keyup="verityMaxLimit()" v-model="adjustInfo.max_limit" maxlength="9" ref="maxLimit">
                </div>
              </div>
              <br />
              <div class="input-group">
                <span class="input-group-addon">備註</span>
                <input class="form-control" placeholder="" type="text" v-model="adjustInfo.remark" maxlength="45">
              </div>
              <br />
            </div>
            <div class="col-xs-12 col-md-6 p-l-5" v-show="!show.easy">
              <div class="input-group">
                <span class="input-group-addon"><span class="text-red">＊ </span>常見價格</span>
                <div class="radio text-left h-38" style="border-left: 1px solid #d2d6de">
                  <label class="m-l-15">
                    <input type="radio" name="commonRadio" :value="1" v-model="adjustInfo.is_common" style="top: 12px;">
                    <div style="top: 8px; left: 8px;">是</div>
                  </label>
                  <label class="m-l-15">
                    <input type="radio" name="commonRadio" :value="0" v-model="adjustInfo.is_common" style="top: 12px;">
                    <div style="top: 8px; left: 8px;">否</div>
                  </label>
                </div>
              </div>
              <br />
              <div class="input-group">
                <span class="input-group-addon">價格</span>
                <input class="form-control" placeholder="調整類別內的選項皆為此價格" type="text" v-model="adjustInfo.price" @keyup="verityPrice()" maxlength="9" ref="price">
              </div>
              <!--<div class="text-right text-15 text-red">(調整類別內的選項皆為此價格)</div>-->
              <br />
              <div class="input-group">
                <span class="input-group-addon">價格類型</span>
                <div class="form-group">
                  <select class="form-control" v-model="adjustInfo.price_type" >
                    <option :value="1">免稅價格</option>
                    <option :value="3">含稅價格</option>
                  </select>
                </div>
              </div>
              <!--<div class="text-right text-15 text-red">(若無價格則無須更動)</div>-->
              <br />
              <div class="input-group">
                <span class="input-group-addon">熱量</span>
                <input class="form-control" placeholder="調整類別內的選項皆為此熱量" type="text" v-model="adjustInfo.calorie" @keyup="verityCalorie()" ref="calorie">
              </div>
              <!--<div class="text-right text-15 text-red">(調整類別內的選項皆為此熱量)</div>-->
              <br />
              <div class="input-group">
                <span class="input-group-addon">描述</span>
                <input class="form-control" placeholder="" type="text" v-model="adjustInfo.description" maxlength="45">
              </div>
              <br />
              <div class="input-group">
                <span class="input-group-addon">商品料號</span>
                <input class="form-control" placeholder="" type="text" v-model="adjustInfo.vendor_custom_id" maxlength="30">
              </div>
              <br />
            </div>
            <div class="col-xs-12">
              <div class="input-group">
                <span class="input-group-addon">配料</span>
                <div class="form-control text-left" style="min-height: 60px">
                  <button class="btn btn-default btn-black m-y-10 inline-block " data-toggle="modal" data-target="#choseModal" style="position: absolute; right: 10px; top: 0px; z-index: 3;">
                    選擇配料
                  </button>
                  <div class="option-left-block">
                    <div class="inline-block m-r-10 option-chose" v-for="option in optionList" style="margin: 5px" v-if="option.active">
                      {{option.name}}
                    </div>
                  </div>
                </div>
              </div>
              <br />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="box-footer text-center">
      <button class="btn btn-default" @click="gotoOut">
        返回
      </button>
      <button
        v-if="!adjustList.length"
        class="btn btn-default btn-black"
        @click="gotoCrAdjusts"
      >
        新增
      </button>
      <button
        v-if="adjustList.length"
        class="btn btn-success"
        @click="checkInputEmpty"
      >
        儲存
      </button>
    </div>
    <br />
    <c-modal :elementList="optionList" :option="choseOption" @trigger="trigger"></c-modal>
    <m-modal class="text-left" :option="delOption" @trigger="trigger"></m-modal>
  </div>
</template>

<script>
import matcherModal from '../../../elements/Modal.vue'
import $ from 'jquery'
import AdjustModal from './AdjustModal.vue'
import OptionModal from './OptionModal.vue'
import { mapActions, mapGetters } from 'vuex'
import ChoseModal from '../../../elements/ChooseModal.vue'
import NdExtendHandleMenu from '@/extends/nd-extend-handle-menu.vue'

export default {
  name: 'CrAdjustTemp',
  props: {
    'info': {
      type: Object
    }
  },
  extends: NdExtendHandleMenu,
  components: {
    'adjust-modal': AdjustModal,
    'option-modal': OptionModal,
    'c-modal': ChoseModal,
    'm-modal': matcherModal
  },
  data () {
    return {
      tableIndex: 1,
      pageGroup: 1,
      groupAmount: 10,
      menuId: this.$route.params.menu_id,
      brandId: this.$route.params.brand_id,
      show: {
        easy: true
      },
      current: {
        option: 0,
        adjust: 0,
        adjustId: 0,
        adjustName: '',
        adjustSubType: 0
      },
      brandName: '',
      brandType: '',
      adjustNumList: [],
      adjust: [],
      option: [],
      amount: {
        adjust: 1,
        option: 1
      },
      count: 20,
      maxTotal: 0,
      adjustList: [],
      optionList: [],
      adjustInfo: {
        name: '',
        sort: 1,
        description: '',
        remark: '',
        price: '',
        price_type: '3',
        calorie: '',
        min_limit: 0,
        max_limit: 1,
        vendor_custom_id: '',
        is_mandatory: '0',
        is_common: '0',
        sub_type: '0'
      },
      choseOption: {
        // 配料modal資料
        id: 'choseModal',
        title: '選擇配料',
        event: 'chooseElement'
      },
      curId: 0,
      oldInfo: {},
      isLoad: false,
      defaultIndex: 1,
      delOption: {
        id: 'delModal',
        title: '刪除配料群組',
        body: '刪除時，若被上架中的菜單使用中，則會被阻擋',
        btns: [
          {
            name: '取消'
          },
          {
            name: '確定',
            event: 'del'
          }
        ]
      }
    }
  },
  methods: {
    ...mapActions(['setUpAdjust', 'setModal']),
    delModalOpen (bind) {
      this.delOption.title = '刪除' + this.adjustInfo.name
    },
    trigger (event) {
      if (event === 'del') {
        this.del(this.adjustInfo.name)
      }
    },
    del (delName) {
      const url = this.base + this.id + '/adjust?adjust_id=' + this.adjustInfo.adjust_id
      this.getDataH('delete', url, null, (response) => {
        if (response.data.status === 200) {
          this.$notify({
            title: '提醒',
            text: '成功刪除' + delName,
            duration: 3000,
            type: 'success',
            width: 400
          })
          this.getMenuAdjust('delete')
        }
      })
    },
    toggle () {
      $(this.$refs.infoAdjustModal).css('display')
    },
    maxAmount (max) {
      if (!max) return '無限制'
      else return max
    },
    getSubType (type) {
      if (type === 10) {
        return '大小'
      } else if (type === 20) {
        return '容器'
      } else if (type === 30) {
        return '甜度'
      } else if (type === 40) {
        return '溫度'
      } else {
        return '其他'
      }
    },
    getPriceType (type) {
      if (type === 1) return '免稅價格'
      else if (type === 3) return '含稅價格'
    },
    veritySort () {
      var e = $(this.$refs.sort)
      this.adjustInfo.sort = e.val()
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/))
      }
    },
    verityMinLimit () {
      var e = $(this.$refs.minLimit)
      this.adjustInfo.min_limit = e.val()
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/))
      }
    },
    verityMaxLimit () {
      var e = $(this.$refs.maxLimit)
      this.adjustInfo.max_limit = e.val()
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/))
      }
    },
    verityPrice () {
      var e = $(this.$refs.price)
      this.adjustInfo.price = e.val()
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/))
      }
    },
    verityCalorie () {
      var e = $(this.$refs.calorie)
      this.adjustInfo.calorie = e.val()
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/))
      }
    },
    clickAdjust (adjust, index) {
      this.isLoad = true
      this.curId = adjust.item_id
      this.defaultIndex = index + 1
      this.getMenuAdjust()
    },
    getAdjustInfo () {
      const url = this.base + this.id + '/adjust/' + this.adjustId
      this.getDataH('get', url, null, (response) => {
        if (response.data.status === 200) {
          url.adjustInfo = response.data.adjust
        }
      })
    },
    checkInputEmpty () {
      if (!this.adjustInfo.sub_type && parseInt(this.adjustInfo.sub_type, 10) !== 0) {
        this.$notify({
          title: '提醒',
          text: '請選擇分類',
          duration: 3000,
          type: 'danger',
          width: 400
        })
      } else if (!this.allInput.name) {
        this.$notify({
          title: '提醒',
          text: '請填寫調整類別名稱',
          duration: 3000,
          type: 'danger',
          width: 400
        })
      } else if (!this.allInput.sort) {
        this.$notify({
          title: '提醒',
          text: '請填寫排序',
          duration: 3000,
          type: 'danger',
          width: 400
        })
      } else if (!parseInt(this.allInput.sort, 10)) {
        this.$notify({
          title: '請填寫正確排序',
          text: '排序範圍為1~9999',
          duration: 3000,
          type: 'danger',
          width: 400
        })
      } else if (!this.allInput.min_limit) {
        this.$notify({
          title: '提醒',
          text: '請填寫最低購買數',
          duration: 3000,
          type: 'danger',
          width: 400
        })
      } else if (!this.allInput.max_limit) {
        this.$notify({
          title: '提醒',
          text: '請填寫最高購買數',
          duration: 3000,
          type: 'danger',
          width: 400
        })
      } else {
        this.upAdjust()
        return true
      }
    },
    upAdjust (type) {
      const url = this.base + this.id + '/adjust/' + this.curId
      var data = {}
      var aInfo = this.adjustInfo
      var oldInfo = this.oldInfo
      if (type === 'sort') {
        data.sort = aInfo.sort
        data.price = aInfo.price
        data.max_limit = aInfo.max_limit
      } else {
        var cList = []
        this.optionList.forEach((element) => {
          if (element.active) cList.push(element.item_id)
        })
        var aList = []
        aInfo.option_list.forEach((element) => {
          aList.push(element.option_id)
        })
        if (aInfo.sub_type !== oldInfo.sub_type) data.sub_type = aInfo.sub_type
        if (aInfo.sort !== oldInfo.sort) data.sort = aInfo.sort
        if (aInfo.name !== oldInfo.name) data.name = aInfo.name
        if (aInfo.vendor_custom_id !== oldInfo.vendor_custom_id) data.vendor_custom_id = aInfo.vendor_custom_id
        if (aInfo.description !== oldInfo.description) data.description = aInfo.description
        if (aInfo.remark !== oldInfo.remark) data.remark = aInfo.remark
        if (aInfo.price !== oldInfo.price) data.price = aInfo.price
        if (aInfo.price_type !== oldInfo.price_type) data.price_type = aInfo.price_type
        if (aInfo.calorie !== oldInfo.calorie) data.calorie = aInfo.calorie
        if (aInfo.is_mandatory !== oldInfo.is_mandatory) data.is_mandatory = aInfo.is_mandatory
        if (aInfo.min_limit !== oldInfo.min_limit) data.min_limit = aInfo.min_limit
        if (aInfo.max_limit !== oldInfo.max_limit) data.max_limit = aInfo.max_limit
        if (aInfo.is_common !== oldInfo.is_common) data.is_common = aInfo.is_common
        if (JSON.stringify(aList) !== JSON.stringify(cList)) {
          data.option_list = cList
        }
      }
      if (data.price === '') data.price = null
      if (JSON.stringify(data) !== '{}') {
        this.getDataH('put', url, data, (response) => {
          if (response.data.status === 200) {
            if (!type) {
              this.$notify({
                title: '提醒',
                text: '已更新' + aInfo.name,
                duration: 3000,
                type: 'success',
                width: 400
              })
            }
            if (aInfo.name !== oldInfo.name) {
              this.getMenuAdjust('reload', aInfo.adjust_id)
            }
          }
        })
      }
    },
    delAdjust () {
      const url = this.base + this.id + '/adjust?adjust_id=' + this.adjustId
      this.getDataH('delete', url, null, (response) => {
        if (response.data.status === 200) {
          this.$notify({
            title: '提醒',
            text: '成功刪除調整類別',
            duration: 3000,
            type: 'success',
            width: 400
          })
          this.editState = false
          const id = this.modalId
          $('#' + id).modal('toggle')
          this.setUpAdjust(true)
        }
      })
    },
    clearData () {
      this.adjustInfo = {
        name: '',
        sort: 1,
        description: '',
        remark: '',
        price: '',
        price_type: '3',
        calorie: '',
        min_limit: '0',
        max_limit: '0',
        adjust_custom_id: '',
        is_mandatory: '0',
        is_common: '0',
        sub_type: '0'
      }
    },
    gotoCrAdjusts () {
      console.log('gotoCrAdjusts')
      let name = ''
      let params = {
        brand_id: this.$route.params.brand_id,
        store_id: ''
      }

      if (this.isStore && this.getRoleType !== 10) {
        name = 'StoreMenuAdjustCreate'
        params.store_id = this.$route.params.store_id
      } else {
        name = 'crAdjusts'
      }

      this.$router.push({ name, params })
    },
    gotoOut () {
      this.$router.go(-1)
    },
    gotoNext () {
      this.$router.push('/upCategory/' + this.brandId)
    },
    getMenuAdjust (type) {
      const url = this.base + this.id + '/adjust/briefList'
      this.getDataH('get', url, null, (response) => {
        if (response.data.status === 200) {
          var adjustList = response.data.list
          this.adjustList = adjustList
          if ((adjustList.length && !this.curId) || type === 'delete') {
            if (this.$route.query.aId) this.curId = parseInt(this.$route.query.aId, 10)
            else this.curId = adjustList[0].item_id
          }
          this.getMenuOption()
        }
      })
    },
    getMenuOption () {
      this.optionList = []
      const url = this.base + this.id + '/option/briefList?type=2'
      this.getDataH('get', url, null, (response) => {
        if (response.data.status === 200) {
          if (response.data.list.length) {
            const optionList = response.data.list[0].child_list
            optionList.forEach((element) => {
              element.active = false
              this.optionList.push(element)
            })
            this.getAdjust()
          } else if (this.curId) {
            this.getAdjust()
          }
        }
      })
    },
    setActiveOption () {
      if (this.adjustInfo.option_list.length) {
        this.adjustInfo.option_list.forEach((o) => {
          const option = {
            active: true,
            description: o.description,
            item_id: o.option_id,
            name: o.name,
            price: o.price,
            remark: o.remark,
            vendor_custom_id: o.vendor_custom_id
          }
          this.optionList.push(option)
          this.isLoad = false
        })
      } else {
        this.isLoad = false
      }
    },
    getAdjust () {
      const url = this.base + this.id + '/adjust/' + this.curId
      this.getDataH('get', url, null, (response) => {
        if (response.data.status === 200) {
          $.each(response.data.adjust, (index, value) => {
            this.$set(this.oldInfo, index, value)
          })
          this.adjustInfo = response.data.adjust
          if (!this.adjustInfo.sort || (!this.adjustInfo.price && parseInt(this.adjustInfo.price, 10) !== 0)) {
            if (!this.adjustInfo.sort) this.adjustInfo.sort = this.defaultIndex
            if (!this.adjustInfo.price && parseInt(this.adjustInfo.price, 10) !== 0) this.adjustInfo.price = ''
            if (!this.adjustInfo.max_limit && parseInt(this.adjustInfo.max_limit, 10) !== 0) this.adjustInfo.max_limit = 1
            this.upAdjust('sort')
          }
          this.setActiveOption()
        }
      })
    }
  },
  created () {
    this.getMenuAdjust()
  },
  computed: {
    ...mapGetters(['getUpAdjust', 'getModal', 'getRoleType']),
    modalState () {
      if (this.state === 3 && !this.editState) return this.adjustInfo.name
      if (this.editState) return '編輯' + this.adjustInfo.name
      else return '新增調整類別'
    },
    allInput () {
      return {
        name: this.checkInput(this.adjustInfo.name),
        sort: this.checkInput(this.adjustInfo.sort),
        vendor_custom_id: this.checkInput(this.adjustInfo.vendor_custom_id),
        description: this.checkInput(this.adjustInfo.description),
        remark: this.checkInput(this.adjustInfo.remark),
        price: this.checkInput(this.adjustInfo.price),
        calorie: this.checkInput(this.adjustInfo.calorie),
        min_limit: this.checkInput(this.adjustInfo.min_limit),
        max_limit: this.checkInput(this.adjustInfo.max_limit)
      }
    },
    getDataH () {
      return this.$parent.getDataH
    },
    checkInput () {
      return this.$parent.checkInput
    },
    productNew () {
      var product = this.product
      return product
    },
    pageAmount () {
      return Math.ceil(this.maxTotal / this.count)
    }
  }
}
</script>

<style lang="sass" scoped>
$default-color: #e1456d
$light-gray: rgb(238, 238, 238)
$primary-color: #3c8dbc

.btn-black, .btn-black:hover, .btn-black:focus, .btn-black:active, .btn-black:active:focus
  border: 1px solid #333333 !important
.m-r-10
  margin-right: 10px
.p-r-5
  padding-right: 5px !important
.p-l-5
  padding-left: 5px !important
.box-body.menu-form
  left: 0
  width: auto
  padding: 0px 10px
.btn.disabled, .btn[disabled], fieldset[disabled] .btn
  cursor: auto
  opacity: 1
.c-auto
  cursor: auto !important
.bg-light-gray
  background: $light-gray
.select-element
  padding: 10px 15px
  cursor: pointer
  border-bottom: 2px solid #ddd
.select-element:last-child
  border-bottom: 0px
.select-element:hover, .select-element.active
  background: $primary-color
  color: #fff
.select-element-block
  margin-bottom: 10px
  max-height: calc(100vh - 360px)
  overflow: scroll
.option-chose
  background: $primary-color
  color: #ffffff
  padding: 6px 12px
.option-left-block
  width: calc(100% - 95px)
@media screen and (max-width: 767px)
  .select-element
    padding: 5px 15px
    font-size: 16px
  .select-element-block
    margin-left: 10px
    margin-right: 10px
    height: 30vh
  .option-left-block
    width: 100%
    padding-top: 45px
</style>



// WEBPACK FOOTER //
// CrAdjustTemp.vue?7796d4ab